import { Component, OnInit } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { Logger } from '@core/logger';
import { OutlookTokensApiService } from '../../../shared/api-repos/outlook-token/outlook-tokens.api.service';
import { CallbackState } from '../../stewart-callback/stewart-callback.component';
import { NavigationService } from '../../../shared/services/nav/nav.service';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';

@Component({
	selector: 'app-outlook-callback',
	templateUrl: './outlook-callback.component.html',
	animations: [openClose()],
	standalone: false,
})
export class OutlookCallbackComponent implements OnInit {
	public ICON = ICON;

	public states = CallbackState;
	public state: CallbackState = CallbackState.acceptProfileId;

	constructor(
		private outlookTokensApiService: OutlookTokensApiService,
		private navigationService: NavigationService,
		private snackbarService: SnackbarService,
	) {}

	async ngOnInit(): Promise<void> {
		console.log('OutlookCallbackComponent: ngOnInit called');
		console.log('Current URL:', window.location.href);
		console.log('Current pathname:', window.location.pathname);
		console.log('Current search:', window.location.search);

		try {
			const urlParams = new URLSearchParams(window.location.search);
			const error = urlParams.get('error');
			const errorDescription = urlParams.get('error_description');

			if (error) {
				Logger.error(`OAuth error: ${error} - ${errorDescription}`);
				this.state = CallbackState.loginError;
				return;
			}

			const tokenResponse =
				await this.outlookTokensApiService.getTokensFromCodeExchange();

			if (tokenResponse) {
				this.state = CallbackState.savedSuccess;
				this.snackbarService.openSnackBar({
					text: 'Outlook account connected successfully!',
					type: 'success',
				});
				Logger.info('Outlook OAuth login successful');
			} else {
				this.state = CallbackState.loginError;
				this.snackbarService.openSnackBar({
					text: 'Failed to connect Outlook account. Please try again.',
					type: 'error',
				});
				Logger.error('Token exchange failed: No access token received');
			}
		} catch (err) {
			this.state = CallbackState.loginError;
			Logger.exception(err);
		} finally {
			this.navigationService.goToProfile();
		}
	}
}
